export default "__VITE_ASSET__CQmQPkt___"